import script from "./UnansweredQuestions.vue?vue&type=script&setup=true&lang=js"
export * from "./UnansweredQuestions.vue?vue&type=script&setup=true&lang=js"

import "./UnansweredQuestions.vue?vue&type=style&index=0&id=2b770c9a&scoped=true&lang=css"
import "./UnansweredQuestions.vue?vue&type=style&index=1&id=2b770c9a&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b770c9a"]])

export default __exports__